var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseGraphQLSitemapService, } from './base-graphql-sitemap-service';
/** @private */
export const languageError = 'The list of languages cannot be empty';
export const siteError = 'The service needs a site name';
/**
 * @param {string} siteName to inject into error text
 * @private
 */
export function getSiteEmptyError(siteName) {
    return `Site "${siteName}" does not exist or site item tree is missing`;
}
/**
 * Service that fetches the list of site pages using Sitecore's GraphQL API.
 * Used to handle a single site
 * This list is used for SSG and Export functionality.
 * @mixes SearchQueryService<PageListQueryResult>
 */
export class GraphQLSitemapService extends BaseGraphQLSitemapService {
    /**
     * Creates an instance of graphQL sitemap service with the provided options
     * @param {GraphQLSitemapServiceConfig} options instance
     */
    constructor(options) {
        super(options);
        this.options = options;
    }
    /**
     * Fetch a flat list of all pages that belong to the specificed site and have a
     * version in the specified language(s).
     * @param {string[]} languages Fetch pages that have versions in this language(s).
     * @param {Function} formatStaticPath Function for transforming the raw search results into (@see StaticPath) types.
     * @returns list of pages
     * @throws {RangeError} if the list of languages is empty.
     * @throws {RangeError} if the any of the languages is an empty string.
     */
    fetchSitemap(languages, formatStaticPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const paths = new Array();
            if (!languages.length) {
                throw new RangeError(languageError);
            }
            const siteName = this.options.siteName;
            if (!siteName) {
                throw new RangeError(siteError);
            }
            paths.push(...(yield this.getTranformedPaths(siteName, languages, formatStaticPath)));
            return [].concat(...paths);
        });
    }
}
